export const GLOBAL_AUTH_ERROR_STORAGE_KEY = 'globalAuthError'
const TOKEN_EXPIRED_HEADER = 'TOKEN_EXPIRED'

const buildQueryString = (query) => {
  const params = new URLSearchParams()
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    params.append(key, String(value))
  })
  const queryString = params.toString()
  return queryString ? `?${queryString}` : ''
}

export const buildUrl = (path, query) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || ''
  const base = apiBaseUrl.replace(/\/+$/, '')
  const cleanPath = path.replace(/^\/+/, '')
  const url = base ? `${base}/${cleanPath}` : `/${cleanPath}`
  return `${url}${buildQueryString(query)}`
}

const parseBody = async (response) => {
  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    return response.json()
  }
  return response.text()
}

export const getAuthHeaders = () => {
  const token = sessionStorage.getItem('token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const handleAuthError = (response) => {
  const authErrorHeader = response.headers.get('X-Auth-Error')
  if (authErrorHeader !== TOKEN_EXPIRED_HEADER) {
     
    return
  }

  const authError = {
    code: TOKEN_EXPIRED_HEADER,
    message: 'Tu sesion ha expirado. Inicia sesion de nuevo.',
    timestamp: new Date().toISOString(),
  }

  localStorage.setItem(GLOBAL_AUTH_ERROR_STORAGE_KEY, JSON.stringify(authError))
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('role')

  if (window.location.pathname !== '/') {
    window.location.assign('/')
  }
}

const throwRequestError = async (response) => {
  handleAuthError(response)
  const errorBody = await parseBody(response)
  const error = new Error(`Request failed with status ${response.status}`)
  error.status = response.status
  error.body = errorBody
  throw error
}

export const requestJson = async ({ method, path, body, query }) => {
  const response = await fetch(buildUrl(path, query), {
    method,
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: body === undefined ? undefined : JSON.stringify(body),
  })

  if (!response.ok) {
    return throwRequestError(response)
  }

  return parseBody(response)
}

export const requestBlob = async ({ method, path, query }) => {
  const response = await fetch(buildUrl(path, query), {
    method,
    headers: { ...getAuthHeaders() },
  })

  if (!response.ok) {
    return throwRequestError(response)
  }

  return response.blob()
}
